import testFnc from "./components/test";
import {swipers} from "./components/swipers";
import {promoAction} from "./components/promo-action";
import {tabs} from "./components/tabs";
import {form} from "./components/form";
import {cookie} from "./components/cookie";
import {mainBannerAnimation} from "./components/main-banner-animation";
import {iframeResize} from "./components/iframe-resize";

testFnc();
swipers()
promoAction()
tabs()
form()
cookie()
mainBannerAnimation()
iframeResize()
